import { createApp } from 'vue'
import piniaPluginPersistedState from 'pinia-plugin-persistedstate';
import {createPinia} from 'pinia';
import App from './App.vue';
import router from './routes';

const app = createApp(App);
const pinia = createPinia();
pinia.use(piniaPluginPersistedState)
app.use(pinia);
app.use(router);

app.mount('#app')
